import React from "react";
import "whatwg-fetch";
import Promise from "promise-polyfill";
import store from "../store";
import { sendOlbKeepAlive } from "./sendOlbKeepAlive";

if (!window.Promise) {
  window.Promise = Promise;
}

export function baseFetch(route, method = "GET", requestBody = null) {
  sendOlbKeepAlive();

  // Check if we have a token from that is associated with an SSO authenticated payment session
  // and if so, use that token. If not, default to old functionality of using the token stored in redux store

  const authPaymentSessionToken = sessionStorage.getItem("_LTjwt");

  let token = authPaymentSessionToken || store.getState().token;
  // if we are not running locally, add api to the route
  var baseUrl = window.location.origin;
  if (!window.location.host.match(/^localhost/)) {
    baseUrl += "/api";
  }
  var url = baseUrl + route;
  let options = {
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      accesstoken: token,
    },
    credentials: "include",
  };
  if (method === "POST") {
    options["body"] = requestBody;
    options["method"] = "POST";
  }
  return fetch(url, options)
    .then((response) => {
      if (response.status >= 400) {
        return response.json().then((error) => {
          return Promise.reject(
            `The api returned the status code ${response.status} with the error message ${error.ExceptionMessage}`
          );
        });
      } else {
        return response.json();
      }
    })
    .then((res) => res);
}

// Use for requests that have no response body, so we don't try to parse the nonexistant json
export function baseFetchWithoutResponse(route, method = "GET", requestBody = null) {
  // Check if we have a token from that is associated with an SSO authenticated payment session
  // and if so, use that token. If not, default to old functionality of using the token stored in redux store

  const authPaymentSessionToken = sessionStorage.getItem("_LTjwt");

  let token = authPaymentSessionToken || store.getState().token;
  // if we are not running locally, add api to the route
  var baseUrl = window.location.origin;
  if (!window.location.host.match(/^localhost/)) {
    baseUrl += "/api";
  }
  var url = baseUrl + route;
  let options = {
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      accesstoken: token,
    },
    credentials: "include",
  };
  if (method === "POST") {
    options["body"] = requestBody;
    options["method"] = "POST";
  }

  return fetch(url, options).then((response) => {
    if (response.status >= 400) {
      return Promise.reject(
        `The api returned the status code ${response.status} with the error message ${response.statusText}`
      );
    }
  });
}



// WEBPACK FOOTER //
// ./src/utils/baseRequest.js